// extracted by mini-css-extract-plugin
export default {"ContactIconItem":"ContactIcon_ContactIconItem__P4nj5","Icon":"ContactIcon_Icon__cTnyQ"};